import { getAccessToken } from '@selectors/auth';
import { readCookie } from '@utils/cookies';
import { getStore } from 'src/redux';

/**
 * Resolves the access token for client-side API calls.
 * Cookie is preferred; redux is used as a fallback right after login
 * (authenticate can run before setCookiesPostLogin finishes writing the cookie).
 */
export const getClientAccessToken = () => {
  if (typeof window === 'undefined') {
    return null;
  }

  const cookieToken = readCookie('accessToken');
  if (cookieToken) {
    return cookieToken;
  }

  try {
    return getAccessToken(getStore().getState()) || null;
  } catch {
    return null;
  }
};

const ACCESS_TOKEN_RETRY_INTERVAL_MS = 50;
const ACCESS_TOKEN_MAX_RETRIES = 5;

const delay = (ms) =>
  new Promise((resolve) => {
    setTimeout(resolve, ms);
  });

const retryGetClientAccessToken = async (attemptsLeft) => {
  if (attemptsLeft <= 0) {
    return null;
  }

  await delay(ACCESS_TOKEN_RETRY_INTERVAL_MS);

  const token = getClientAccessToken();
  if (token) {
    return token;
  }

  return retryGetClientAccessToken(attemptsLeft - 1);
};

/** Waits briefly for cookie/redux token after login before giving up. */
export const resolveAccessTokenForRequest = async () => {
  const immediate = getClientAccessToken();
  if (immediate) {
    return immediate;
  }

  return retryGetClientAccessToken(ACCESS_TOKEN_MAX_RETRIES);
};
